import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({ editScreen, TenantFilterCell }) => {
  const dataColumns = [
    {
      field: 'SRFDeviceId',
      title: 'Device Id',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'SerialNum',
      title: 'Serial Number',
      editable: false,
      show: true,
      width: '350px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.SerialNum}
        </td>
      ),
    },
    {
      field: 'TenantId',
      title: 'Tenant Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      excludeFromFilter: true,
    },
    {
      field: 'TenantName',
      title: 'Tenant',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterCell: (props) =>
        TenantFilterCell({
          ...props,
          filterType: 'dropdown',
        }),
    },
    {
      field: 'LocaleId',
      title: 'Locale Id',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFVendorName',
      title: 'Vendor Name',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFDispayWidth',
      title: 'Display Width',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFDispayHeight',
      title: 'Display Height',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
  ];

  return dataColumns;
};
export default DataColumns;
